import React from "react";
import { IimageSlideComponentProps } from "../types/props";
import {  EDirection } from "../enums";
import closeImage from "../../assets/close.svg";
import ReactTooltip from "react-tooltip";
import "./imageSlide.component.scss";

const ImageSlideComponent = ({
  index,
  title,
  image,
  moveSlide,
  removeSlide,
  last,
}: IimageSlideComponentProps) => {
  const up = ():void => {
    moveSlide(index, EDirection.up);
  };
  const down = ():void => {
    moveSlide(index, EDirection.down);
  };
  const remove = ():void => {
    removeSlide(index);
  };

  return (
    <>
      <ReactTooltip
        backgroundColor="rgb(0, 51, 89)"
      />
      <div className="image-slide">
        <div className="image-slide--left">
          <div className="image-slide--buttons">
            <button
              className="image-slide--up"
              disabled={index === 0}
              onClick={up}
            >
              <span className="sr-only">Move Up</span>
            </button>
            <button
              className="image-slide--down"
              disabled={last}
              onClick={down}
            >
              <span className="sr-only">Move Down</span>
            </button>
            <span className="image-slide--index">{index + 1}</span>
          </div>
        </div>
        <div className="image-slide--right">
          <button className="image-slide--remove" onClick={remove}>
            <img src={`/dist/${closeImage}`} />
            <span className="sr-only">Remove</span>
          </button>
          <h2 data-tip={title.length > 30 ? title : null}>{title}</h2>
          <img src={image} />
        </div>
      </div>
    </>
  );
};

export default ImageSlideComponent;
